// extracted by mini-css-extract-plugin
module.exports = {"bootcampCarousel":"BootcampCarousel_bootcampCarousel__nVKUo","conatiner":"BootcampCarousel_conatiner__l_Wvd"};